import i18n from "i18next";
import { type FC, useCallback } from "react";

import { PrimaryButton } from "../Buttons/components/ActionButton";

export type SubmitButtonProps = {
    isDisabled: boolean;
    onClick: () => void;
    onBeforeNavigate?: () => void;
};

export const SubmitButton: FC<SubmitButtonProps> = ({ isDisabled, onClick, onBeforeNavigate }) => {
    const callback = useCallback(() => {
        if (onBeforeNavigate) onBeforeNavigate();
        onClick();
    }, [onBeforeNavigate, onClick]);

    return (
        <PrimaryButton name="save_form" onClick={callback} disabled={isDisabled}>
            {i18n.t("button.save")}
        </PrimaryButton>
    );
};
